import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPostById } from '../services/blogApi';

const N  = '#0A2540';
const E  = '#7C4DFF';
const ED = '#6030E8';

export default function BlogPost() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPostById(id)
      .then(res => setPost(res.data))
      .catch(() => setPost(null))
      .finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [id]);

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F5F7FA' }}>
      <i className="fas fa-spinner fa-spin" style={{ color: E, fontSize: '3rem' }} />
    </div>
  );

  if (!post) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16, background: '#F5F7FA' }}>
      <div style={{ fontSize: '4rem' }}>😕</div>
      <h2 style={{ color: N }}>Post not found</h2>
      <Link to="/blog" style={{ color: ED, fontWeight: 600 }}>← Back to Blog</Link>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#F5F7FA' }}>
      {/* Hero */}
      <div style={{
        background: `linear-gradient(135deg, ${N} 0%, #0D3060 55%, #003828 100%)`,
        padding: '140px 24px 60px',
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'radial-gradient(rgba(124,77,255,0.04) 1px, transparent 1px)',
          backgroundSize: '40px 40px', pointerEvents: 'none',
        }} />
        <div style={{ maxWidth: 800, margin: '0 auto', position: 'relative' }}>
          {post.category && (
            <span style={{
              background: 'rgba(124,77,255,0.15)', color: E,
              padding: '4px 14px', borderRadius: 20, fontSize: '0.82rem', fontWeight: 600,
              display: 'inline-block', marginBottom: 16,
              border: '1px solid rgba(124,77,255,0.35)',
            }}>
              {post.category}
            </span>
          )}
          <h1 style={{
            fontFamily: "'Poppins', sans-serif", fontWeight: 800,
            fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)', color: '#fff', lineHeight: 1.3, marginBottom: 20,
          }}>
            {post.title}
          </h1>
          <div style={{ display: 'flex', gap: 20, color: 'rgba(255,255,255,0.42)', fontSize: '0.85rem', flexWrap: 'wrap' }}>
            <span><i className="fas fa-user" style={{ marginRight: 6, color: E }} />Dennis Kuria</span>
            {post.publishedAt && (
              <span>
                <i className="fas fa-calendar" style={{ marginRight: 6, color: E }} />
                {new Date(post.publishedAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Cover Image */}
      {post.coverImageUrl && (
        <div style={{ maxWidth: 800, margin: '-40px auto 0', padding: '0 24px' }}>
          <img src={post.coverImageUrl} alt={post.title}
            style={{ width: '100%', borderRadius: 14, boxShadow: '0 20px 60px rgba(10,37,64,0.18)', display: 'block' }} />
        </div>
      )}

      {/* Content */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '60px 24px 80px' }}>
        <div
          className="blog-content"
          style={{
            background: '#fff', borderRadius: 14, padding: '40px 48px',
            boxShadow: '0 4px 20px rgba(10,37,64,0.08)',
            fontSize: '1.02rem', lineHeight: 1.9, color: '#4A5568',
          }}
          dangerouslySetInnerHTML={{ __html: post.content }}
        />

        {/* Back / CTA */}
        <div style={{ marginTop: 40, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <Link to="/blog" style={{
            color: ED, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 8,
            transition: 'color 0.2s',
          }}
            onMouseEnter={e => { e.currentTarget.style.color = E; }}
            onMouseLeave={e => { e.currentTarget.style.color = ED; }}
          >
            <i className="fas fa-arrow-left" /> Back to Blog
          </Link>
          <Link to="/#contact" style={{
            background: E, color: '#fff', padding: '10px 22px',
            borderRadius: 8, fontWeight: 600, fontSize: '0.9rem',
            boxShadow: '0 4px 16px rgba(124,77,255,0.28)',
            transition: 'all 0.2s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = ED; }}
            onMouseLeave={e => { e.currentTarget.style.background = E; }}
          >
            Work with Dennis
          </Link>
        </div>
      </div>

      <style>{`
        .blog-content h1, .blog-content h2, .blog-content h3 { color: ${N}; margin-bottom: 12px; margin-top: 32px; }
        .blog-content p { margin-bottom: 18px; }
        .blog-content img { max-width: 100%; border-radius: 8px; }
        .blog-content a { color: ${ED}; }
        .blog-content a:hover { color: ${E}; }
        .blog-content blockquote {
          border-left: 4px solid ${E}; padding: 12px 20px;
          background: rgba(124,77,255,0.05); border-radius: 0 8px 8px 0; margin: 24px 0;
        }
        @media (max-width: 600px) {
          .blog-content { padding: 24px 20px !important; }
        }
      `}</style>
    </div>
  );
}
